import { titleStyle } from "../../hooks/useClassName";

const CheckBoxForOnChange = ({
  title,
  name,
  value,
  setField,
  primaryField,
  setFieldMulti,
  index,
  classNameTitle,

  label,
  disabled = false,
  fontLabelWeight = "font-semibold",
  other_value = [],

  className = "flex justify-start items-center  space-x-2 rounded-xl my-4 mx-11",
}) => {
  const onChangeCheckbox = (e) => {
    const value = e.target.checked;
    setField(name)(value);

    if (other_value.length > 0) {
      console.log("1");
      other_value.forEach((item) => {
        setField(item)(false);
      });
    }

    if (primaryField) {
      return setFieldMulti(name, primaryField, index)(value);
    }
  };
  return (
    <div>
      <div className={classNameTitle ? classNameTitle : titleStyle}>
        {title}
      </div>
      <div className={className}>
        <input
          type="checkbox"
          name={name}
          checked={value}
          onChange={onChangeCheckbox}
          disabled={disabled}
        />
        <div
          className={
            "md:text-lg text-base text-textblue mx-10" + fontLabelWeight
          }
        >
          {label}
        </div>
      </div>
    </div>
  );
};
export default CheckBoxForOnChange;
